export const initGnavSubToggle = () => {
  const wraps = document.querySelectorAll('.js-gnav-sub');
  const subNavs = document.querySelectorAll('.js-sub-nav');

  if (!wraps.length) return;

  const triggers = Array.from(wraps, wrap => wrap.querySelector('.g-nav__trigger')).filter(Boolean);

  // SPアコーディオンメニューの開閉（見出し行全体をクリック領域にする）
  wraps.forEach(wrap => {
    const trigger = wrap.querySelector('.g-nav__trigger');
    if (!trigger) return;

    wrap.addEventListener('click', () => {
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      // 全て閉じる
      triggers.forEach(t => t.setAttribute('aria-expanded', 'false'));
      subNavs.forEach(s => s.setAttribute('aria-hidden', 'true'));
      // クリックしたものだけ開く
      if (!isExpanded) {
        trigger.setAttribute('aria-expanded', 'true');

        const targetId = trigger.getAttribute('aria-controls');
        const target = document.getElementById(targetId);

        if (target) {
          target.setAttribute('aria-hidden', 'false');
        }
      }
    });
  });

  // リサイズ時に一時的にサブナビを非表示
  let resizeTimer;
  window.addEventListener('resize', () => {
    subNavs.forEach(sub => {
      sub.style.display = 'none';
    });
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      subNavs.forEach(sub => {
        sub.style.display = '';
      });
    }, 200);
  });
};